module.exports = __webpack_public_path__ + "media/images/athletes/3429-e41eea99581918637ce6807419f0dcd5.png";